export default "__VITE_ASSET__xNxBZNvU__"